import React, { useState } from 'react';

/**
 * TextInputModal component for inputting answers to NO_ANSWER questions
 * 
 * @param {Object} props
 * @param {string} props.initialValue - Initial input value
 * @param {Function} props.onSubmit - Function to handle form submission
 * @param {Function} props.onCancel - Function to handle modal cancellation
 * @param {string} props.question - The question text to display
 */
const TextInputModal = ({ initialValue = '', onSubmit, onCancel, question }) => {
  const [inputValue, setInputValue] = useState(initialValue);
  
  const handleSubmit = () => {
    onSubmit(inputValue);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 pb-4 sm:pb-0">
      <div className="bg-white/50 rounded-lg w-[90%] max-w-sm p-6 space-y-4 backdrop-blur-sm mb-safe">
        <p className="text-center text-black text-lg mb-4 font-semibold">
          答えを入力して下さい。
        </p>
        <div className="bg-[#E8E8F0] p-3 rounded-lg mb-4">
          <p className="text-sm text-gray-600 mb-2">
            {question || 'この質問に答えを入力してください。'}
          </p>
        </div>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="テキストを入力"
          className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#34d399]"
          autoFocus
        />
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={onCancel}
            className="bg-gray-500 text-white px-8 py-3 rounded-full text-lg font-medium shadow-lg active:transform active:scale-95 transition-transform"
          >
            キャンセル
          </button>
          <button
            onClick={handleSubmit}
            className="bg-[#34d399] text-white px-8 py-3 rounded-full text-lg font-medium shadow-lg active:transform active:scale-95 transition-transform"
          >
            送信
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextInputModal; 